import Img from 'gatsby-image'
import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import theme from '../utils/theme'

const Gallery = styled.div`
  min-height: 100%;
  padding: 1rem;

  @media (min-width: 32rem) {
    padding: 2rem;
  }

  @media (min-width: 64rem) {
    padding: 3rem;
  }
`

const GalleryGrid = styled.ul`
  list-style: none;
  padding-left: 0;
`

const GalleryImageContainer = styled.li`
  margin-bottom: 1rem;
  padding: 0.5rem;
  background-color: white;
  border-bottom: 1px solid rgba(0,0,0,0.15);

  @media (min-width: 32rem) {
    margin-bottom: 2rem;
  }

  @media (min-width: 64rem) {
    margin-bottom: 3rem;
  }
`

const GalleryPage = ({data}) => (
  <Gallery>
    <Helmet>
      <title>Photos of Landscaping Work by {data.site.siteMetadata.title}</title>
    </Helmet>
    <h1>
      Photo Gallery
    </h1>
    <GalleryGrid>
      {data.allFile.edges.map(({ node }, index) =>
        <GalleryImageContainer key={index}>
          <Img
            sizes={node.childImageSharp.sizes} 
            alt={data.site.siteMetadata.title}
            style={{maxHeight: '90vh'}}
          />
        </GalleryImageContainer>
      )}
    </GalleryGrid>
  </Gallery>
)

export default GalleryPage

export const query = graphql`
  query GalleryQuery {
    allFile(filter: { sourceInstanceName: { eq: "gallery" } }, sort: { fields: [name], order: ASC }) {
      edges {
        node {
          childImageSharp {
            sizes(maxWidth: 768) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/gallery.js